import { VerticalMediaSchema, type VerticalMedia } from '@selenos/leads';

/**
 * Spitex landing-page media.
 *
 * Two exports, one per side (supply = caregiver recruitment,
 * demand = patient/family acquisition). Each side has its own hero
 * video and a curated set of section videos thematically matched to
 * that side's section copy.
 */

export const spitexSupplyMedia: VerticalMedia = VerticalMediaSchema.parse({
  hero: {
    default: {
      image: {
        src: '/images/landing/spitex/hero/supply-desktop.jpeg',
        mobile: '/images/landing/spitex/hero/supply-mobile.jpeg',
        alt: '',
      },
      video: {
        mp4: '/videos/landing/spitex/hero/supply-desktop.mp4',
        poster: '/images/landing/spitex/hero/supply-desktop.jpeg',
      },
    },
    cities: {},
  },
  sections: {
    connection: {
      image: {
        src: '/images/landing/spitex/sections/supply-connection.jpeg',
        alt: 'Pflegefachperson im Gespraech mit einer Patientin',
      },
      video: {
        mp4: '/videos/landing/spitex/sections/haende-halten.mp4',
        poster: '/images/landing/spitex/sections/supply-connection.jpeg',
      },
    },
    'on-the-road': {
      image: {
        src: '/images/landing/spitex/sections/supply-ontheroad.jpeg',
        alt: 'Pflegefachperson unterwegs mit dem Fahrrad',
      },
      video: {
        mp4: '/videos/landing/spitex/sections/spaziergang.mp4',
        poster: '/images/landing/spitex/sections/supply-ontheroad.jpeg',
      },
    },
    autonomous: {
      image: {
        src: '/images/landing/spitex/sections/supply-autonomous.jpeg',
        alt: 'Pflegefachperson arbeitet selbststaendig bei einem Patienten zu Hause',
      },
    },
    team: {
      image: {
        src: '/images/landing/spitex/sections/supply-team.jpeg',
        alt: 'Spitex-Pflegeteam bei einer Besprechung',
      },
    },
  },
  testimonials: {},
});

export const spitexDemandMedia: VerticalMedia = VerticalMediaSchema.parse({
  hero: {
    default: {
      image: {
        src: '/images/landing/spitex/hero/demand-desktop.jpeg',
        mobile: '/images/landing/spitex/hero/demand-mobile.jpeg',
        alt: '',
      },
      video: {
        mp4: '/videos/landing/spitex/hero/demand-desktop.mp4',
        poster: '/images/landing/spitex/hero/demand-desktop.jpeg',
      },
    },
    cities: {},
  },
  sections: {
    consultation: {
      image: {
        src: '/images/landing/spitex/sections/demand-consultation.jpeg',
        alt: 'Beratungsgespraech zwischen Pflegefachperson und Familie',
      },
    },
    independence: {
      image: {
        src: '/images/landing/spitex/sections/demand-independence.jpeg',
        alt: 'Aeltere Person lebt selbststaendig zu Hause mit Unterstuetzung',
      },
      video: {
        mp4: '/videos/landing/spitex/sections/am-fenster.mp4',
        poster: '/images/landing/spitex/sections/demand-independence.jpeg',
      },
    },
    'family-relief': {
      image: {
        src: '/images/landing/spitex/sections/demand-family-relief.jpeg',
        alt: 'Familie wird durch professionelle Pflege entlastet',
      },
      video: {
        mp4: '/videos/landing/spitex/sections/kueche-mit-mama.mp4',
        poster: '/images/landing/spitex/sections/demand-family-relief.jpeg',
      },
    },
    'post-hospital': {
      image: {
        src: '/images/landing/spitex/sections/demand-post-hospital.jpeg',
        alt: 'Patient erhaelt Nachsorge zu Hause nach einem Spitalaufenthalt',
      },
    },
  },
  testimonials: {},
});
